import ButtonInput from './ButtonInput';
import PropTypes from 'prop-types';
import React from 'react';


export class SiteSearch extends React.Component{
  state = {};

  constructor(props){
    super(props);
    this._rootRef = React.createRef();
  }

  componentDidMount(){
    window.addEventListener('click', this.document_onClick);
    window.addEventListener('ontouchstart', this.document_onClick);
    window.addEventListener('touchstart', this.document_onClick);
  }
  componentWillUnmount(){
    window.removeEventListener('click', this.document_onClick);
    window.removeEventListener('ontouchstart', this.document_onClick);
    window.removeEventListener('touchstart', this.document_onClick);
    window.clearTimeout(this._closeTimer);
  }


  document_onClick = (e) => {
    const root = this._rootRef.current;
    if(root && root.contains(e.target)){
      return;
    }
    this.closeSearch(e);
  };

  closeSearch = (e) => {
    if(this.props.onBlur) this.props.onBlur(e);
  };

  onContainerBlur = () => {
    this.scheduleCloseIfFocusLeft();
  };

  scheduleCloseIfFocusLeft(){
    window.clearTimeout(this._closeTimer);
    this._closeTimer = window.setTimeout(() => {
      if(this._pointerDownOnResult){
        this._pointerDownOnResult = false;
        return;
      }
      const root = this._rootRef.current;
      if(root && root.contains(document.activeElement)){
        return;
      }
      this.closeSearch();
    }, 0);
  };
  results_onPointerDown = (e) => {
    if(!e.target.closest('a, button')){
      return;
    }
    this._pointerDownOnResult = true;
    // Mouse: keep focus on the input so blur doesn't close results before click.
    if(e.pointerType === 'mouse'){
      e.preventDefault();
    }
  };
  form_onSubmit = (e) => {
    if(this.props.onSubmit) this.props.onSubmit(e);
    e.preventDefault();
  };
  siteSearch_onClick = (e) => {
    // console.log(`siteSearch_onClick`);
    this.siteSearch_onFocus(e);
    if(this.props.onFocus) this.props.onFocus(e);
    e.stopPropagation();
  };
  siteSearch_onFocus = (e) => {
    var currentTarget = e.currentTarget;

    setTimeout(() => {
      if(currentTarget.contains(document.activeElement)){
        // console.log('component officially focused');
        if(this.props.onFocus) this.props.onFocus(e);
      }
    }, 0);
  };


  render(){
    //console.log(`SiteSearch render`, this.state, this.props);

    let openClass = this.props.isOpen ? 'is-open' : '';

    return (
      <div ref={this._rootRef}
           className={`site-search ${this.props.className || ''} ${openClass}`}
           onClick={this.siteSearch_onClick}
           onPointerDown={this.props.onPointerDown}
           onFocus={this.siteSearch_onFocus}
           onBlur={this.onContainerBlur}>
        <form onSubmit={this.form_onSubmit} className='site-search__form'>

          <ButtonInput onClearClick={this.props.onClearClick}
                       onInputChange={this.props.onInputChange}
                       ariaLabelledBy={this.props.ariaLabelledBy}
                       inputAriaLabel={this.props.inputAriaLabel}
                       inputID={this.props.inputID}
                       inputPlaceholder={this.props.inputPlaceholder}
                       defaultValue={this.props.defaultValue}
                       required={this.props.required}
                       isLoading={this.props.isLoading}
                       isOpen={this.props.isOpen}/>

          <div className="site-search__button">
            <button type="submit"
                    className="site-search__submit-pill tg-button tg-button--pill tg-button--blue">
              <span className="tg-button__label">Search</span>
            </button>
          </div>

        </form>
        <div className="site-search__results">
          <div className="site-search__results-container"
               onPointerDown={this.results_onPointerDown}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}


SiteSearch.propTypes = {
  ariaLabelledBy: PropTypes.string,
  children: PropTypes.object,
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  inputAriaLabel: PropTypes.string,
  inputID: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onBlur: PropTypes.func,
  onClearClick: PropTypes.func,
  onFocus: PropTypes.func,
  onInputChange: PropTypes.func,
  onPointerDown: PropTypes.func,
  onSubmit: PropTypes.func,
  required: PropTypes.bool,
};
